var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCccdTf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.33333H4C2.89333 1.33333 2 2.21999 2 3.31333V10.5867C2 11.68 2.89333 12.5733 4 12.5733H4.50667C5.03333 12.5733 5.54667 12.78 5.92 13.1533L7.06 14.28C7.58 14.7933 8.42 14.7933 8.94 14.28L10.08 13.1533C10.4533 12.78 10.9667 12.5733 11.4933 12.5733H12C13.1067 12.5733 14 11.68 14 10.5867V3.31333C14 2.21999 13.1067 1.33333 12 1.33333ZM8 3.7C8.72 3.7 9.3 4.28666 9.3 4.99999C9.3 5.70666 8.74 6.27333 8.04667 6.29999C8.02 6.29999 7.98 6.29999 7.94667 6.29999C7.24667 6.27333 6.69333 5.70666 6.69333 4.99999C6.7 4.28666 7.28 3.7 8 3.7ZM9.83333 9.79333C8.82667 10.4667 7.17333 10.4667 6.16667 9.79333C5.28 9.20666 5.28 8.23333 6.16667 7.64C7.18 6.96666 8.83333 6.96666 9.83333 7.64C10.72 8.23333 10.72 9.2 9.83333 9.79333Z",
    fill: "#808985"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCccdTf);
export default __webpack_public_path__ + "static/media/icon_cccdTF.eef6fe71e6b217f023e2b059327313b6.svg";
export { ForwardRef as ReactComponent };